import { gql } from '@/__generated__';

const CREATE_DEVICE_REPORT = gql(`#graphql
  mutation CreateDeviceReport($input: ReportDeviceProblemInput!) {
    reportDeviceProblem(input: $input)
  }
`);

export default CREATE_DEVICE_REPORT;
